import { styled } from '@mui/system'

export const Root = styled('div')`
	min-height: 45px;
	margin: ${({ theme }) => theme.spacing(2)} auto 0;
	text-align: center;
`
